import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
// import {
//   DiscountStatusEnum,
//   DiscountValueTypeEnum
// } from "@saleor/types/globalTypes";
import {
  createDateField
  // createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum RegisterFilterKeys {
  created = "created"
}

export interface RegisterFilterOpts {
  // saleType: FilterOpts<DiscountValueTypeEnum>;
  // started: FilterOpts<MinMax>;
  // status: FilterOpts<DiscountStatusEnum[]>;
  created: FilterOpts<MinMax>;
}

const messages = defineMessages({
  // active: {
  //   defaultMessage: "Active",
  //   description: "sale status"
  // },
  // expired: {
  //   defaultMessage: "Expired",
  //   description: "sale status"
  // },
  // fixed: {
  //   defaultMessage: "Fixed amount",
  //   description: "discount type"
  // },
  // percentage: {
  //   defaultMessage: "Percentage",
  //   description: "discount type"
  // },
  // scheduled: {
  //   defaultMessage: "Scheduled",
  //   description: "sale status"
  // },
  // started: {
  //   defaultMessage: "Started",
  //   description: "sale start date"
  // },
  // status: {
  //   defaultMessage: "Status",
  //   description: "sale status"
  // },
  // type: {
  //   defaultMessage: "Discount Type"
  // }
  created: {
    defaultMessage: "created"
  }
});

export function RegistercreateFilterStructure(
  intl: IntlShape,
  opts: RegisterFilterOpts
): IFilter<RegisterFilterKeys> {
  return [
    {
      ...createDateField(
        RegisterFilterKeys.created,
        intl.formatMessage(messages.created),
        opts.created.value
      ),
      active: opts.created.active
    }
    // {
    //   ...createOptionsField(
    //     SaleFilterKeys.status,
    //     intl.formatMessage(messages.status),
    //     opts.status.value,
    //     true,
    //     [
    //       {
    //         label: intl.formatMessage(messages.active),
    //         value: DiscountStatusEnum.ACTIVE
    //       },
    //       {
    //         label: intl.formatMessage(messages.expired),
    //         value: DiscountStatusEnum.EXPIRED
    //       },
    //       {
    //         label: intl.formatMessage(messages.scheduled),
    //         value: DiscountStatusEnum.SCHEDULED
    //       }
    //     ]
    //   ),
    //   active: opts.status.active
    // },
    // {
    //   ...createOptionsField(
    //     SaleFilterKeys.saleType,
    //     intl.formatMessage(messages.type),
    //     [opts.saleType.value],
    //     false,
    //     [
    //       {
    //         label: intl.formatMessage(messages.fixed),
    //         value: DiscountValueTypeEnum.FIXED
    //       },
    //       {
    //         label: intl.formatMessage(messages.percentage),
    //         value: DiscountValueTypeEnum.PERCENTAGE
    //       }
    //     ]
    //   ),
    //   active: opts.saleType.active
    // }
  ];
}
